var render = function render(){var _vm=this,_c=_vm._self._c;return _c('demographics-template',{attrs:{"date-of-birth":_vm.dateOfBirth,"gender":_vm.gender,"genotype":_vm.genotype,"genotype-visible":_vm.genotypeVisible,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }